import React from 'react';
import { Box, Typography } from '@mui/material';

const GoalHeader = ({
  goalNumber,
  goalNo,
  subGoalIndex,
  goalTitle,
  subGoalName,
}) => {
  return (
    <Box display='grid' gridTemplateColumns='1fr auto 1fr' alignItems='center'>
      <Typography variant='body1' fontWeight='bold'>
        Goal # {goalNumber || goalNo}
        {subGoalIndex
          ? subGoalName
            ? `, ${subGoalName}`
            : `, Subgoal #${subGoalIndex}`
          : ''}
      </Typography>
      <Typography fontWeight='bold' textAlign='center'>
        {goalTitle}
      </Typography>
      <Box />
    </Box>
  );
};

export default GoalHeader;
